import { ApiP3MetricsResponse, P3Metrics } from "@/core/dashboard/entities/P3Metrics";
import { toColorIndicator } from "./colorIndicatorMapper";

/**
 * Maps GET /api/v1/dashboard/compliance/p3/metrics to the P3Metrics domain model.
 */
export default class P3MetricsMapper {
  static toDomain(api: ApiP3MetricsResponse): P3Metrics {
    return {
      alertSummary: {
        possibleMatchCount: api.alertSummary?.possibleMatchCount ?? null,
        clearCount: api.alertSummary?.clearCount ?? 0,
        totalEvaluated: api.alertSummary?.totalEvaluated ?? 0,
        falsePositiveRate: api.alertSummary?.falsePositiveRate ?? null,
        avgBacklogAgeDays: api.alertSummary?.avgBacklogAgeDays ?? null,
        triageColorIndicator: toColorIndicator(
          api.alertSummary?.triageColorIndicator,
        ),
        falsePositiveColorIndicator: toColorIndicator(
          api.alertSummary?.falsePositiveColorIndicator,
        ),
      },
      eddWorkflowAvailable: api.eddWorkflowAvailable ?? false,
      avgEddProcessingDays: api.avgEddProcessingDays ?? null,
    };
  }
}
